// Effective CSS viewport width below which list views collapse toolbars and the
// sidebar auto-collapses.
//
// Derived from 1920px at 110% browser zoom (1920 / 1.1 ≈ 1745px). Rounded up to
// 1750 so tight layout also covers 125% zoom on 1920 (1536px) and 100% on 1536
// displays, while staying OFF at 1920×1080 @ 100% zoom (~1920px).
export const TIGHT_VIEWPORT_MAX_WIDTH = 1750;

// Fixed header height — matches .secondaryTabs { top: 80px } in AdminUsersViews.css.
export const APP_CONTENT_TOP_OFFSET = 80;
